<template>
  <!-- <AppBar /> -->
  <router-view name="navbar"></router-view>
  <div class="w80 center my-5">
    <p>Your Search Criteria:</p>
    <span v-for="(value, name, index) in searchResultJSON[0]" :key="index">
      <span v-if="value !== 0">
        &nbsp;<b>{{ name !== "ocr" && name !== "full" ? name : "" }}</b
        >{{ name !== "ocr" && name !== "full" ? ":" : "" }}
        {{ value.toString() }}
      </span>
    </span>
    <div>
      <div class="d-flex justify-sm-end">
        <v-responsive max-width="344" class="mr-2">
          <v-text-field density="compact" label="Template"></v-text-field>
        </v-responsive>
        <div class="d-flex">
          <v-btn min-height="45">Save</v-btn>
        </div>
      </div>
    </div>
    <h1 class="mt-4 text-h6 font-weight-regular" style="color: #00cae3">
      Customize Your Excel Report
    </h1>
    <v-divider class="border-opacity-100 pb-5" color="#00CAE3"></v-divider>
    <!-- global checkboxes -->
    <div class="checkbox-grid">
      <div v-for="(row, rowIndex) in globalCheckboxes" :key="rowIndex">
        <!-- <div>{{ JSON.stringify(row) }}</div> -->
        <!-- <div
          v-for="(checkbox, index) in row"
          :key="index"
          class="checkbox-item"
        > -->
        <!-- <checkbox :name="checkbox"></checkbox> -->
        <input type="checkbox" :id="row.value" />
        <label style="margin-left: 5px">{{ row.key }}</label>
        <!-- </div> -->
      </div>
    </div>
    <!-- <div v-show="additionDetailsSection">
      <AdditionalDetails
        :headingName="`Additional Details`"
        :categoryName="Incentives"
        :refinedCheckboxesName="groupedIncentivesCheckboxes"
      />
    </div> -->
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <div v-show="!additionDetailsSection">
      <AdditionalDetails
        :headingName="`Additional Details`"
        :categoryName="Incentives"
        :refinedCheckboxesName="additionalDetailsCheckboxes"
      />
    </div>

    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <div v-show="!additionVariablesection">
      <AdditionalDetails
        :headingName="`Additional Variables`"
        :categoryName="`Consumer Report`"
        :refinedCheckboxesName="additionalVariablesCheckboxes"
      />
      <v-spacer></v-spacer>
      <!-- <AdditionalDetails
        :categoryName="`Demographics`"
        :refinedCheckboxesName="groupedDemographics"
      /> -->
    </div>
    <!-- <div v-show="additionDetailsSection">
      <v-divider
        class="border-opacity-100 pb-5"
        style="border-top: 1px dotted #00cae3"
      ></v-divider>
      <div>
        Additional Details <span style="color: #00cae3">Select All</span>
      </div>
      <div>Incentives <span style="color: #00cae3">Select All</span></div>
      <div class="checkbox-grid">
        <div
          v-for="(row, rowIndex) in groupedIncentivesCheckboxes"
          :key="rowIndex"
        >
          <div
            v-for="(checkbox, index) in row"
            :key="index"
            class="checkbox-item"
          >
            <input type="checkbox" :id="checkbox" />
            <label :for="checkbox">{{ checkbox }}</label>
          </div>
        </div>
      </div>
    </div> -->
    <v-spacer></v-spacer>
    <v-spacer></v-spacer>
    <!-- excel buttons -->
    <div class="checkbox-grid pt-10">
      <div>
        <p style="cursor: pointer" @click="toggleAdditionalDetails">
          <span v-if="additionDetailsSection">Show Additional Details</span>
          <span v-if="!additionDetailsSection">Hide Additional Details</span>
        </p>
        <p style="cursor: pointer" @click="toggleAdditionalVariables">
          <span v-if="additionVariablesection">Show Additional Variables</span>
          <span v-if="!additionVariablesection">Hide Additional Variables</span>
        </p>
      </div>
      <div>
        <p>File Type</p>
        <v-radio-group>
          <v-radio label="Excel (.xlsx)" value="one"></v-radio>
          <v-radio label="Excel (.xls)" value="two"></v-radio>
          <v-radio label="Comma Separated Value (.csv)" value="three"></v-radio>
        </v-radio-group>
      </div>
      <div>
        <v-btn color="primary" class="top-btns ma-2"
          >GENERATE FILE FOR CURRENT PAGE</v-btn
        >
        <v-btn color="primary" class="top-btns ma-2"
          >GENERATE FILE FOR ALL RECORDS</v-btn
        >
        <v-btn color="primary" class="top-btns ma-2"
          >COMPREHENSIVE BANKING REPORT</v-btn
        >
        <v-btn color="primary" class="top-btns ma-2"
          >PANELIST REPORT (PANELIST ID)</v-btn
        >
        <v-btn color="primary" class="top-btns ma-2"
          >PANELIST REPORT (ENTRY ID)</v-btn
        >
      </div>
    </div>

    <!-- customize chart -->

    <div class="text-h6 font-weight-regular pb-3" style="color: #00cae3">
      Customize Your Chart
    </div>
    <v-divider class="border-opacity-100" color="#00CAE3"></v-divider>
    <!-- chart options -->
    <div class="checkbox-grid pt-10">
      <div>
        <v-select
          class="dropdown-charttype"
          :items="chartOptions"
          density="compact"
          label="Chart Type"
        ></v-select>
        <div>
          <p>Records</p>
          <v-radio-group>
            <v-radio label="All" value="one"></v-radio>
            <div class="d-flex" style="width: 300px">
              <v-radio label="Top" value="two"></v-radio>
              <v-text-field label="5"></v-text-field>
            </div>
          </v-radio-group>
          <v-select
            class="dropdown-charttype1"
            :items="chartTime"
            density="compact"
          ></v-select>
        </div>
      </div>
      <div>
        <v-select
          class="dropdown-charttype"
          :items="datafield"
          density="compact"
          label="Data Field"
        ></v-select>
      </div>
      <div>
        <div>
          <v-select
            class="dropdown-charttype"
            :items="datafield"
            density="compact"
            label="Data Field"
          ></v-select>
          <v-responsive max-width="305" class="mr-2">
            <v-text-field density="compact" label="Title"></v-text-field>
          </v-responsive>
          <v-btn color="primary" class="top-btns ma-2"
            >Generate Chart for all Records</v-btn
          >
        </div>
      </div>
    </div>

    <!-- <div class="d-flex justify-space-between">
      <div v-for="n in checkboxesNames" :key="n">
        <checkbox :name="n"></checkbox>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { watchEffect, ref } from "vue";
// import VerticalSpacer from "../VerticalSpacer.vue";
import AdditionalDetails from "./AdditionalDetails.vue";

import { useStore } from "vuex";
// import checkbox from "./CheckBox.vue";
// import AppBar from "../../AppBar.vue";

const store = useStore();
const searchResultJSON = ref([]);
// const checkboxesNames = [
//   "All",
//   "Audience",
//   "Mail Piece Months",
//   "Primary Company",
//   "Communication Type",
//   "Email Volume Estimates",
//   "Additional Companies",
//   "Affinity/Association",
//   "First Seen",
//   "Sector",
//   "Affinity/Association Name",
//   "Last Seen",
//   "Primary Sector",
//   "Affinity/Association Category",
//   "Offer Expiry Date",
//   "Category",
//   "Affinity/Association Sub-Category",
//   "File Size",
//   "Primary Category",
//   "Product",
//   "Delivery Method",
//   "Sub Category",
//   "Age",
//   "Response Mechanism",
//   "Primary Sub Category",
//   "Income",
//   "PDF Content",
//   "Sub Sub Category",
//   "State/Province",
//   "Pre-Screen & Opt-Out Notice",
//   "Primary Sub Sub Category",
//   "Country",
//   "Credit Union",
//   "Mailing Type",
//   "Campaign Language",
//   "Personalization",
//   "Entry ID",
//   "Mail Pieces",
//   "Target Markets",
//   "Quarter",
//   "Estimated Mail Volume",
//   "Business Content",
//   "Headline",
//   "Estimated Mail Spend",
//   "Affinion",
//   "Media Channel",
//   "Real Time Mail Volume",
//   "Group Size",
//   "Estimated Digital Spend ($) / Impressions",
//   "Mail Piece Months",
//   "Simple Domain",
//   "EDC / LDC / TDSP",
//   "Personalization",
//   "SEM Search Key",
//   "SEM Url",
//   "Offer Origin",
//   "Fee Product",
//   "Riders",
//   "SEM Headline",
//   "SEM Description",
//   "Quarter",
// ];

// const incentives = [
//   "Sign-on Incentive Maximum Spend #2",
//   "Free Checking",
//   "Ongoing Incentive",
//   "Sign-on Incentive Minimum Spend #2",
//   "Checking APR (%)",
//   "Sign-on Incentive #1",
//   "Sign-on Incentive Window (months) #2",
//   "Checking APY (%)",
//   "Sign-on Incentive Type #1",
//   "Sign-on Limited to Specific Category #2",
//   "Savings APR (%)",
//   "Sign-on Incentive Value #1",
//   "Sign-on Fixed date #2",
//   "Savings APY (%)",
//   "Sign-on Accelerator Per #1",
//   "Sign-on Incentive #3	",
//   "Money Market APR (%)",
//   "Sign-on Accelerator Type #1",
//   "Sign-on Incentive Type #3",
//   "Money Market APY (%)",
//   "Sign-on Max award #1	",
//   "Sign-on Incentive Value #3	",
//   "C/D APR (%)",
//   "Sign-on Incentive Maximum Spend #1	",
//   "Sign-on Accelerator Per #3	",
//   "C/D APY (%)",
//   "Sign-on Incentive Minimum Spend #1	",
//   "Sign-on Accelerator Type #3	",
//   "Sign-on Incentive Window (months) #1	",
//   "Sign-on Max award #3	",
// ];
// const PaymentCards = [
//   "Application Type	",
//   "Card Network	",
//   "Primary Card Level	",
//   "Secondary Card Level(s)	",
//   "Rewards Program	",
//   "Rewards Program Emphasis	",
//   "Rewards Rate	",
//   "Reloadable"
// ]

// const regularPricing = [
//   "Tier 1 Purchase Regular APR (%)	", "Tier 2 Purchase Regular APR (%)	", "Tier 3 Purchase Regular APR (%)	", "Purchase Regular APR (%) Detail	",
//   "Purchase Regular Rate Type	", "Tier 1 Balance Transfer Regular APR (%)	",
//   "Tier 2 Balance Transfer Regular APR (%)	", "Tier 3 Balance Transfer Regular APR (%)	",
//   "Balance Transfer Regular APR (%) Detail	", "Balance Transfer Regular Rate Type	",
//   "Tier 1 Cash Advance Regular APR (%)	",  "Tier 2 Cash Advance Regular APR (%)	",
//   "Tier 3 Cash Advance Regular APR (%)	", "Cash Advance Regular APR (%) Detail	",
//   "Cash Advance Regular Rate Type	"
//]

const chartTime = ref([
  "Consumer Trend Over Time (Month)",
  "Consumer Trend Over Time (Quarter)",
  "Consumer Trend Over Time (Year)",
]);

const additionDetailsSection = ref(true);
const additionVariablesection = ref(true);
const datafield = ref(["Company", "Age"]);

// const groupByThree = (array) => {
//   const groupedArray = [];
//   for (let i = 0; i < array.length; i += 3) {
//     groupedArray.push(array.slice(i, i + 3));
//   }
//   return groupedArray;
// };
//const groupedCheckboxes = ref(groupByThree(checkboxesNames));
// const groupedIncentivesCheckboxes = ref(groupByThree(incentives));
const chartOptions = ref([
  "Pie",
  "Bar",
  "Excel",
  "Powerpoint-Pie",
  "Powerpoint-Bar",
]);

// const consumerReport = [
//   "Panelist Affinities",
//   "Panelist Loyalty/Retention, Statement Companies",
//   "Invitation ID",
//   "Last 4 Digits",
// ];

// const Demographics = ["Zip/Postal Code", "ATP", "Income360", "DSDollar", "DSI"];
// const groupedconsumerReport = ref(groupByThree(consumerReport));
// const groupedDemographics = ref(groupByThree(Demographics));
const globalCheckboxes = ref([]);
const additionalDetailsCheckboxes = ref([]);
const additionalVariablesCheckboxes = ref([]);
function toggleAdditionalDetails() {
  additionDetailsSection.value = !additionDetailsSection.value;
}

function toggleAdditionalVariables() {
  additionVariablesection.value = !additionVariablesection.value;
}
watchEffect(() => {
  let ser = store.getters["Rawdata/getsearchCriteriaGlobalGetter"];
  searchResultJSON.value = ser;
  let allcheckboxesLocal = store.getters["Myexcel/getExcelCheckBoxesNames"];
  // console.log(11, allcheckboxesLocal);
  Object.keys(allcheckboxesLocal).filter((key) => {
    if (key === "default") {
      globalCheckboxes.value = allcheckboxesLocal[key];
    } else if (key === "additional variables") {
      additionalDetailsCheckboxes.value = allcheckboxesLocal[key];
    } else if (key === "additional details") {
      additionalVariablesCheckboxes.value = allcheckboxesLocal[key];
    }
  });
  // console.log(ser, "Ser");
  // console.log(globalCheckboxes.value);
  // console.log(additionalDetailsCheckboxes.value);
  // console.log(additionalVariablesCheckboxes.value);
});
</script>
<style scoped>
.w80 {
  width: 80% !important;
}

.center {
  margin: 0 auto;
}

.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.checkbox-item {
  display: flex;
  align-items: center;
}
.checkbox-item label {
  margin-left: 5px;
}

.top-btns {
  height: 30px !important;
  width: 300px;
}

.dropdown-charttype {
  width: 66% !important;
}

.dropdown-charttype1 {
  width: 66% !important;
}

.textField {
  width: 59% !important;
}
</style>
